import { useContext, useCallback } from 'react';
import axios from 'axios';
import { AuthContext } from '../Contexts/AuthContext';
import CONSTANTS from '../Constants/ApiConstants';
import CustomAlert from '../Components/CustomAlert';


const authHeader = async () => {
    const userToken = await localStorage.getItem(CONSTANTS.STORE.USER_TOKEN);
    // const { getUser, user } = useUser();
    // console.log("OT",userToken)
    // const userToken = await storageSystem.get(CONSTANTS.STORE.USER_TOKEN);
    // const obj = JSON.parse(localStorage.getItem("authUser"))

    if (userToken) {
        return { Authorization: userToken }
    } else {
        return {}
    }
}


// Axios instance for standard requests
const axiosApi = axios.create({
    baseURL: CONSTANTS.API_URL,
});

// Separate instance for FormData to avoid content-type issues
const formAxios = axios.create({
    baseURL: CONSTANTS.API_URL,
});

// Set global interceptors once for each instance
axiosApi.interceptors.request.use(
    async (config) => {
        const headers = await authHeader();
        config.headers = {
            ...(config.headers || {}),
            ...headers,
        };
        return config;
    },
    (error) => Promise.reject(error)
);

formAxios.interceptors.request.use(
    async (config) => {
        const headers = await authHeader();
        config.headers = {
            ...(config.headers || {}),
            "Content-Type": "multipart/form-data",
            ...headers,
        };
        return config;
    },
    (error) => Promise.reject(error)
);

export const useApi = () => {
    const { signOut } = useContext(AuthContext);

    const handleError = useCallback((err) => {
        let message;

        if (err?.response) {
            const { status, data } = err.response;
            console.log("🚀 ~ handleError ~ status:", status)

            if (!data?.status && Array.isArray(data?.error)) {
                throw new Error(data?.error?.[0]?.message || 'Unknown error');
            }

            switch (status) {
                case 404:
                case 422:
                    message = (typeof data == 'object' ? (Array.isArray(data) ? (typeof data[0] == 'object' ? data[0]?.message : data[0]) : (data.error || data.message)) : data) || 'Sorry! The page you are looking for could not be found.';
                    break;
                case 400:
                case 500:
                    message = (typeof data == 'object' ? (Array.isArray(data) ? (typeof data[0] == 'object' ? data[0]?.message : data[0]) : (data.error || data.message)) : data) || 'Sorry! Something went wrong. Please contact our support team.';
                    break;
                case 401:
                    message = 'logout';
                    // CustomAlert({
                    //     type: "success",
                    //     title: "Session Expired!",
                    //     message: "Your login session has expired, Please login again.",
                    //     confirmText: 'Signout',
                    //     onConfirm: () => { return signOut?.() }
                    // })
                    // Alert.alert(
                    //     'Session Expired!',
                    //     'Your login session has expired, Please login again.',
                    //     [{ text: 'LOGIN', onPress: () => { return signOut?.() } }],
                    //     { cancelable: true }
                    // );
                    // signOut?.();
                    break;
                default:
                    message = err?.message || 'Something went wrong';

            }
            
            if (message === 'logout') {
                CustomAlert({
                    type: "error",
                    title: "Session Expired!",
                    message: "Your login session has expired, Please login again.",
                    confirmText: 'Signout',
                    onConfirm: () => { return signOut?.() }
                })
            } else {
                CustomAlert({
                    type: "error",
                    title: "Error!",
                    message: message,
                    confirmText: 'Okay',
                })
            }
        } else {
            message = err?.message || 'Something went wrong';
        }

        throw { message, error: message };
    }, [signOut]);

    const get = useCallback(async (url, config = {}) => {
        try {
            const response = await axiosApi.get(url, config);
            return response.data;
        } catch (err) {
            handleError(err);
        }
    }, [handleError]);

    const post = useCallback(async (url, data, config = {}) => {
        try {
            const response = await axiosApi.post(url, data, config);
            return response.data;
        } catch (err) {
            handleError(err);
        }
    }, [handleError]);

    const put = useCallback(async (url, data, config = {}) => {
        try {
            const response = await axiosApi.put(url, data, config);
            return response.data;
        } catch (err) {
            handleError(err);
        }
    }, [handleError]);

    const del = useCallback(async (url, config = {}) => {
        try {
            const response = await axiosApi.delete(url, config);
            return response.data;
        } catch (err) {
            handleError(err);
        }
    }, [handleError]);

    const postFormData = useCallback(async (url, data, config = {}) => {
        try {
            const response = await formAxios.post(url, data, config);
            return response.data;
        } catch (err) {
            handleError(err);
        }
    }, [handleError]);

    const putFormData = useCallback(async (url, data, config = {}) => {
        try {
            const response = await formAxios.put(url, data, config);
            return response.data;
        } catch (err) {
            handleError(err);
        }
    }, [handleError]);

    const getAsync = useCallback(async (url, config = {}) => {
        try {
            const response = await formAxios.get(url, config);
            return response.data;
        } catch (err) {
            try {
                await handleError(err);
            } catch (message) {
                return { status: false, response: message.message };
            }
        }
    }, [handleError]);

    const postAsync = useCallback(async (url, data, config = {}) => {
        try {
            const response = await axiosApi.post(url, data, config);
            return response.data;
        } catch (err) {
            try {
                await handleError(err);
            } catch (message) {
                return { status: false, response: message.message };
            }
        }
    }, [handleError]);

    return {
        get,
        post,
        postFormData,
        putFormData,
        put,
        del,
        getAsync,
        postAsync,
    };
};
